import DraftsIcon from "@mui/icons-material/Drafts";
import ListReportDisPostOffice3 from "./List";

//params
export const REPORT_DISCOUNT_POST_OFFICE_3 = "editions/reference-three";

//permissions

export const resources = {
  isMenu: true,
  icon: <DraftsIcon />,
  name: REPORT_DISCOUNT_POST_OFFICE_3,
  title: "Справка - 3",
  list: <ListReportDisPostOffice3 />,
  permission: "editions",
};

//api url
